module.exports = __webpack_public_path__ + "img/ssru-logo.534af9e8.png";